<template>
  <div class="post">
    <van-nav-bar :title="topTitle" :rightText="lang.topclear" :left-arrow="!$route.query.fromapp" @click-left="prev" @click-right="clear" />
    <div class="tit">
      <span class="num">2</span>
      <span class="titname">{{ lang.agencyInformation }}</span>
    </div>
    <!-- 表单 -->
    <van-cell-group>
      <!-- 当地产代理证（propertyUserInfo.agentCardPath）有数据  禁用表单输入 只供展示  -->
      <!-- 是否展示 代理公司资料及个人地产代理牌照 -->
      <van-cell
        required
        :title="lang.companyShow"
        is-link
        :value="companyInfo.isHideCompanyInfo === '' ? '' : companyInfo.isHideCompanyInfo === false ? lang.show : lang.notShow"
        @click="chooseHide"
      />
      <van-popup v-model="companyShow" position="top" class="choose" :overlay="false">
        <van-nav-bar :title="lang.companyShow" left-arrow @click-left="companyShow = false" :right-text="lang.confirm" @click-right="companyShow = false" />
        <van-radio-group v-model="companyInfo.isHideCompanyInfo">
          <van-cell :title="lang.show" clickable @click="comShow(false)">
            <van-radio :name="false" checked-color="#ED1818" />
          </van-cell>
          <van-cell :title="lang.notShow" clickable @click="comShow(true)">
            <van-radio :name="true" checked-color="#ED1818" />
          </van-cell>
        </van-radio-group>
      </van-popup>
      <van-field v-model="companyInfo.companyNameCN" required :label="lang.companyName" input-align="right" maxlength="50" type="text" />
      <van-field v-model="companyInfo.companyNameEN" :label="lang.companyNameEng" input-align="right" maxlength="50" type="text" />
      <van-field v-model="companyInfo.companyTel" required :label="lang.companyPhone" input-align="right" type="tel" @click="post.goPosition($event, $route.query.fromapp)" />
      <van-field v-model="companyInfo.customerTel" :label="`${lang.chinaMobile}${lang.not86}`" input-align="right" type="tel" @click="post.goPosition($event, $route.query.fromapp)" />
      <van-field v-model="companyInfo.companyAddress" :label="lang.companyAddress" input-align="right" maxlength="50" type="text" @click="post.goPosition($event, $route.query.fromapp)" />
    </van-cell-group>
    <van-cell-group class="spacing">
      <van-field
        v-model="companyInfo.companyLicenceNumber"
        required
        :label="lang.companyLicense"
        input-align="right"
        maxlength="20"
        type="text"
        @click="post.goPosition($event, $route.query.fromapp)"
      />
      <van-field
        :disabled="Boolean(companyInfo.agentCardPath)"
        v-model="companyInfo.agentLicenceNumber"
        required
        :label="lang.personalLicense"
        input-align="right"
        maxlength="20"
        type="text"
        @click="post.goPosition($event, $route.query.fromapp)"
      />
      <van-cell :title="lang.agentCard" v-if="companyInfo.agentCardPath && propertyInfo.Source == 1" required>
        <template slot="default">
          <img :src="companyInfo.agentCardPath | imgResize('user')" onerror="errorImg(this,'user')" alt="" height="50" />
        </template>
      </van-cell>
      <van-cell :title="lang.agentCard" v-if="companyInfo.agentCardPath === '' && propertyInfo.Source == 1" required>
        <template slot="default">
          <van-uploader :after-read="onRead" :max-size="5242880" accept="image/png, image/jpeg, image/jpg">{{ lang.upload }}</van-uploader>
        </template>
      </van-cell>
    </van-cell-group>
    <div class="next">
      <van-button class="nextBtn" @click="prev">{{ lang.prev }}</van-button>
      <van-button class="nextBtn" @click="next" :class="{ opc: VerifyNext }">{{ lang.next }}</van-button>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import lang from './../../../common/language/post';
import post from './../../../common/js/post';
export default {
  name: 'step2',
  data() {
    return {
      cacheNum: '',
      post,
      lang,
      topTitle: '',
      userInfo: '',
      query: '',
      companyShow: false,
      companyInfo: {
        isHideCompanyInfo: '',
        companyNameCN: '',
        companyNameEN: '',
        companyTel: '',
        customerTel: '',
        companyAddress: '',
        companyLicenceNumber: '',
        agentLicenceNumber: '',
        agentCardPath: ''
      }
    };
  },
  created() {
    this.topTitle = post.getTitle(this, this.lang);
    if (this.propertyUserInfo) {
      this.getState();
    }
    post.getQuery(this);
  },
  computed: {
    ...mapState(['propertyUserInfo', 'propertyInfo']),
    VerifyNext() {
      if (this.propertyInfo.Source === 1 && this.propertyInfo.propertySource == 2) {
        if (
          this.companyInfo.companyNameCN &&
          this.companyInfo.companyTel &&
          this.companyInfo.agentCardPath &&
          this.companyInfo.companyLicenceNumber &&
          this.companyInfo.agentLicenceNumber &&
          this.companyInfo.isHideCompanyInfo !== ''
        ) {
          return false;
        } else {
          return true;
        }
      } else {
        if (
          this.companyInfo.companyNameCN &&
          this.companyInfo.companyTel &&
          this.companyInfo.companyLicenceNumber &&
          this.companyInfo.agentLicenceNumber &&
          this.companyInfo.isHideCompanyInfo !== ''
        ) {
          return false;
        } else {
          return true;
        }
      }
    }
  },
  methods: {
    ...mapMutations(['setUserData', 'stepChange', 'clearStep2', 'setAgentData']),
    getState() {
      // console.log(this.propertyUserInfo)
      this.companyInfo = Object.assign(this.companyInfo, this.propertyUserInfo);
    },
    /**代理证上传*/
    onRead(file) {
      let formData = new FormData();
      formData.append('file', file.file);
      if (!file.file.name.toLocaleLowerCase().match(/(.*)\.(jpg|jpeg|png)$/)) {
        this.$notify(lang.fileError);
        return;
      }
      this.axios
        .post(this.pub.getApi().Upload, formData)
        .then(res => {
          if (res.data.code === 0 && res.data.result) {
            // console.log(res.data.result[0].url);
            this.companyInfo.agentCardPath = res.data.result[0].url;
          } else {
            this.$notify(lang.picfailure);
          }
        })
        .catch(e => {
          /**上传失败 */
          this.$notify(lang.picfailure);
        });
    },

    prev() {
      this.setUserData({ ...this.companyInfo });
      this.$router.push('/post/step1/' + this.query);
      this.stepChange(1);
    },
    next() {
      if (this.validate_required()) {
        this.setUserData({ ...this.companyInfo });
        this.$router.push('/post/step3/' + this.query);
        this.stepChange(3);
      }
    },
    comShow(val) {
      this.companyInfo.isHideCompanyInfo = val;
    },
    chooseHide() {
      // if (this.propertyUserInfo.agentCardPath) return; //如果已经上传当前代理证，不允许修改
      this.companyShow = !this.companyShow;
    },
    clear() {
      this.$dialog
        .confirm({
          title: lang.Clearcontent,
          cancelButtonText: lang.cancel,
          confirmButtonText: lang.confirm
        })
        .then(() => {
          //  1.清空 vuex 中的数据
          this.clearStep2();
          //  2. 清空本页面的v-model 的数据
          this.companyInfo.companyNameCN = '';
          this.companyInfo.companyNameEN = '';
          this.companyInfo.companyTel = '';
          this.companyInfo.customerTel = '';
          this.companyInfo.companyAddress = '';
          this.companyInfo.companyLicenceNumber = '';
          this.companyInfo.agentLicenceNumber = '';
          this.companyInfo.isHideCompanyInfo = '';
          this.companyInfo.agentCardPath = '';
        })
        .catch(() => {});
    },
    validate_required() {
      if (this.companyInfo.isHideCompanyInfo === '') {
        this.$notify(lang.require2.companyShow);
        return;
      }
      if (!this.companyInfo.companyNameCN || !this.companyInfo.companyNameCN.trim()) {
        this.$notify(lang.require2.companyName);
        return;
      }
      if (!this.companyInfo.companyTel || this.companyInfo.companyTel == '') {
        this.$notify(lang.require2.companyPhone);
        return;
      }
      if (post.verifTel(this.companyInfo.companyTel)) {
        this.$notify(lang.require2.companyTelFormat);
        return;
      }
      if (this.companyInfo.customerTel && !/^[1][3,4,5,7,8,9]\d{9}$/.test(this.companyInfo.customerTel)) {
        this.$notify(lang.require2.TelFormat);
        return;
      }
      if (!this.companyInfo.companyLicenceNumber || !this.companyInfo.companyLicenceNumber.trim()) {
        this.$notify(lang.require2.companyLicense);
        return;
      }
      if (!this.companyInfo.agentLicenceNumber || !this.companyInfo.agentLicenceNumber.trim()) {
        this.$notify(lang.require2.personalLicense);
        return;
      }
      /**当第一次获取为业主 并且只有本次选择为代理的时候 才需要做 地产代理证的验证*/
      if (this.propertyInfo.Source == 1 && this.propertyInfo.propertySource == 2) {
        if (this.companyInfo.agentCardPath === '') {
          this.$notify(lang.require2.agentCardPath);
          return;
        }
      }

      return true;
    }
  },
  beforeDestroy() {
    this.setUserData({ ...this.companyInfo });
  }
};
</script>

<style lang="scss" scoped>
.opc {
  opacity: 0.5;
}
.van-nav-bar {
  border-bottom: 1px solid #e3e4e6;
  background-color: #fafbfc;
}
.van-nav-bar__title {
  font-size: 17px;
  font-weight: 600;
}
.van-nav-bar__text {
  color: #333;
}
.van-nav-bar .van-icon {
  font-size: 25px;
  color: black;
}
// 修改vant label 宽度

/deep/.van-field__label {
  max-width: 180px;
}
/deep/ .van-cell__title span {
  display: inline-block;
  width: 220px;
}

.spacing {
  margin-top: 18px;
}
.choose {
  height: 100%;
  background-color: #f5f6f7;
  // 修改title 文字大小
  /deep/ .van-nav-bar__title {
    font-size: 15px;
  }
}
</style>
